<template>
  <v-card class="sim-phone" elevation="2">
    <div class="sim-phone__header">
      <v-avatar size="36" color="primary" class="mr-3">
        <v-icon dark>mdi-account</v-icon>
      </v-avatar>
      <div>
        <div class="sim-phone__contact">{{ contactName }}</div>
        <div class="sim-phone__subtitle">Mock SMS thread</div>
      </div>
    </div>
    <v-divider />
    <div ref="scroller" class="sim-phone__scroll">
      <div v-if="loading && messages.length === 0" class="sim-phone__empty">
        <v-progress-circular indeterminate size="24" />
      </div>
      <div v-else-if="messages.length === 0" class="sim-phone__empty">
        No messages yet. Trigger today's prompt to start.
      </div>
      <div
        v-for="m in messages"
        :key="m.id"
        class="sim-phone__bubble-row"
        :class="`sim-phone__bubble-row--${m.side}`"
      >
        <div class="sim-phone__bubble" :class="`sim-phone__bubble--${m.side}`">
          <div class="sim-phone__bubble-body">{{ m.body }}</div>
          <div class="sim-phone__bubble-meta">
            <span v-if="m.kind && m.kind !== 'INBOUND'" class="sim-phone__bubble-kind">
              {{ m.kind }}
            </span>
            <span v-if="m.timestamp">{{ formatTime(m.timestamp) }}</span>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SimulatorPhonePane',
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    contactName: {
      type: String,
      default: 'Tenant',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    messages() {
      this.$nextTick(() => this.scrollToBottom())
    },
  },
  mounted() {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom() {
      const el = this.$refs.scroller
      if (el) el.scrollTop = el.scrollHeight
    },
    formatTime(ts) {
      try {
        const d = new Date(ts)
        return d.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sim-phone {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 480px;

  &__header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
  }

  &__contact {
    font-weight: 600;
    font-size: 1rem;
  }

  &__subtitle {
    font-size: 0.75rem;
    color: $bh-gray--2;
  }

  &__scroll {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    background: $bh-blue--4;
  }

  &__empty {
    color: $bh-gray--2;
    text-align: center;
    padding: 24px 0;
    font-size: 0.875rem;
  }

  &__bubble-row {
    display: flex;
    margin-bottom: 8px;

    &--received {
      justify-content: flex-start;
    }
    &--sent {
      justify-content: flex-end;
    }
  }

  &__bubble {
    max-width: 75%;
    padding: 8px 12px;
    border-radius: 16px;
    font-size: 0.875rem;
    line-height: 1.3;
    word-wrap: break-word;

    &--received {
      background: $bh-white;
      color: $bh-black;
      border-bottom-left-radius: 4px;
    }

    &--sent {
      background: $bh-blue;
      color: $bh-white;
      border-bottom-right-radius: 4px;
    }
  }

  &__bubble-body {
    white-space: pre-wrap;
  }

  &__bubble-meta {
    margin-top: 4px;
    font-size: 0.7rem;
    opacity: 0.7;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }

  &__bubble-kind {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
  }
}
</style>
